import { CustomCalendarType } from "@ac-expo/api-types";
import FullCalendar from "@fullcalendar/react";
import {
  isPlanningGroup,
  PlanningEvent,
  PlanningEventCard,
  PlanningEventGroup,
} from "@ui/components/ui/planning";
import dayjs from "dayjs";

export const getRenderEventContent = ({
  isRegisterEnabled,
  customCalendar,
  onOpenActivitiesDetails,
}: {
  isRegisterEnabled?: boolean;
  customCalendar?: CustomCalendarType;
  onOpenActivitiesDetails?: (events: PlanningEvent[]) => void;
}) => {
  const renderEventContent: FullCalendar["props"]["eventContent"] = (
    eventInfo
  ) => {
    const calendarEvent = eventInfo.event;
    const event: PlanningEvent | PlanningEventGroup = {
      id: calendarEvent.id,
      title: calendarEvent.title,
      start: calendarEvent.startStr,
      end: calendarEvent.endStr,
      allDay: calendarEvent.allDay,
      activityId: calendarEvent.extendedProps.activityId,
      allEvents: calendarEvent.extendedProps.allEvents,
      isFree: calendarEvent.extendedProps.isFree,
      createdBy: calendarEvent.extendedProps.createdBy,
      isRegistered: calendarEvent.extendedProps.isRegistered,
      isRegistrationRequired:
        calendarEvent.extendedProps.isRegistrationRequired,
      blockColor: calendarEvent.extendedProps.blockColor,
      hasAvailableTicketTypes: calendarEvent.extendedProps.hasAvailableTicketTypes,
      areaName: calendarEvent.extendedProps.areaName,
      weekStart: dayjs(calendarEvent.startStr).startOf("week").toDate(),
    };

    const withRegister =
      !isPlanningGroup(event) && event.isRegistrationRequired;

    return (
      <PlanningEventCard
        event={event}
        openDetails={onOpenActivitiesDetails}
        withRegister={isRegisterEnabled && withRegister}
        customCalendar={customCalendar}
        isMobile={false}
      />
    );
  };

  return renderEventContent;
};
